import { Injectable } from "@angular/core";
import { API_METHODS, API_URL } from "common/constants/sm-constants";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
import { DatePipe } from "@angular/common";
import { MentoringDocumentModel } from "common/models/page-models/mentoring-document/mentoring-document-data.model";
import { FormDataService } from "../../base-data-services/form-data.service";


@Injectable({
    providedIn: 'root'
})
export class MentoringDocFormDataService extends FormDataService<MentoringDocumentModel> {
    constructor(http: SmApiService, protected override ss: SystemService, private datePipe: DatePipe) {
        super(API_URL.addStudentMentoringDoc, http, ss);
    }

    override getEditUrlAndMethod() {
        const edit = {
            url: '',
            method: API_METHODS.post
        }
        return edit;
    }

    createInstance(): MentoringDocumentModel {
        return new MentoringDocumentModel();
    }

    override getUpdatePayload(data) {
        let payload;
        payload = {
            student_id: JSON.parse(this.systemService.getlocalStorage('profile')).id,
            studentMentoringDocId: data.id,
        };
        return payload;
    }

    override getPostDataType() {
        return false
    }

    // override modifyModel(model, metamodel = null) {
    //     model['student_id'] = JSON.parse(this.systemService.getlocalStorage('profile')).id;
    //     return model;
    // }

    // override modifyAPIResponse(response: any) {
    //     return response['detail'][0];
    // }

    override getUpdateUrl() {
        return API_URL.editStudentMentoringDoc;
    }

}

export { FormDataService };
